var render = function render(){var _vm=this,_c=_vm._self._c;return _c('module-wrapper',{attrs:{"instance":_vm.instance}},[_c('MgsExpander',[_c('template',{slot:"head"},[_vm._v(_vm._s(_vm.instance.buttonText))])],2),_c('hr'),_c('p',[_vm._v("More Information Content")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }